<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part-no" id="pt-1"><em>Part One</em></h1>
<h1 class="part-title">C<span class="smallcaps">ONCEPTUAL</span> O<span class="smallcaps">VERVIEW</span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 011_Part01.vue?e2d311e4